import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ExcelExportPayloadAudit, ExcelExportPayloadRecommendation } from '../models/ExcelExportPayload';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ExcelexportService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);
  blobOption = { responseType: 'blob' as 'json' };
  exportListRecommendation(data: ExcelExportPayloadRecommendation): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.getConfiguration().apiHost + '/api/excel/recommendations',
      data,
      this.blobOption
    );
  }

  exportListAudit(data: ExcelExportPayloadAudit): Observable<Blob> {
    return this.http.post<Blob>(
      this.configService.getConfiguration().apiHost + '/api/excel/audits',
      data,
      this.blobOption
    );
  }
}
